export const IconsSize = 40;
export const LocationTitle = 'Select Location';
